import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { ButtonToolbar, DropdownButton } from 'react-bootstrap';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';
import TagsInput from './SmartTagInput';
import Modal from '../Modal/Modal';
import GenericButton from '../GenericButton';
import CategoryDropdown from './CategoryDropdown';
import CategorizedCustomDropdown from './CategorizedCustomDropdown';
// import CategorySubCatgDropdownList from './CategorySubCatgDropdownList';
import {
  numberWithCommas,
  encodeQueryString,
  checkWeightType,
  isAllFeaturePresent,
  roundWeighted,
} from '../../../util/CommonUtils';
import { buildAutoCodeObject } from '../../../util/autocodeUtils';
import { checkKeywords } from '../../autocode/AutocodeFunctions';
import { getDicForDefKeywords } from '../../../actions/autocodeActions';

import { availableToAddSpecificSelection } from '../../../util/SalesCatalystUtils';
import { getSmartSearchData } from '../../../util/SmartSearchUtils';
import { saveSearchTrackingData } from '../../../util/trackerUtils';
import * as definitionActions from '../../../actions/definitionActions';
import * as dictionaryActions from '../../../actions/dictionaryActions';
import * as crosstabActions from '../../../actions/crosstabActions';
import * as loginActions from '../../../actions/loginActions';
import * as qtsActions from '../../../actions/qtsActions';
import * as geographyActions from '../../../actions/geographyActions';
import CategorySubCatgDropdownList from './CategorySubCatgDropdownList';
import * as geoMappingActions from '../../../actions/geoMappingActions';

import {
  INSIGHT_360_LESS_BASE_WARNING,
  INSIGHT360_EXPLORE,
  INSIGHT360_REPORTS,
  SALES_CATALYST_DATA_SELECTION,
  FLEX_STUDY_TAG,
  CROSSTAB_CONSTANT,
  DATAHAUL_CONSTANT,
  QUICKREPORTS_CONSTANT,
  INSIGHT_360_SAMPLE_SIZE_WARNING,
  AUTOCODE_ACCESS_ID,
} from '../../../constants';
import { MME_MODULE } from '../../mme/MMEConstants';
import { GEO_MAP_MODULE } from '../../geoMap/GeoMapConstant';
import * as urls from '../../../actions/urlTypes';
import { GEOGRAPHY_BASES } from '../../../actions/actionTypes';

const modalDictionaryWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

const modalDataHaulWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const targetMaxLimitModalStyle = {
  width: '30%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const runReportModalStyle = {
  width: '30%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const compareStrings = (v1, v2) => {
  const uV1 = v1.shortText.toUpperCase().replace(' +', ' ');
  const uV2 = v2.shortText.toUpperCase().replace(' +', ' ');
  if (uV1 < uV2) {
    return -1;
  }
  if (uV1 > uV2) {
    return 1;
  }
  return 0;
};

const OPERATORS_MAP = {
  AND: {
    node: '',
    recType: ' ',
    keyword: 'AND',
    shortText: 'AND',
    shortTextCatgView: 'AND',
    objectType: 'operator',
  },
  OR: {
    node: '',
    recType: ' ',
    keyword: 'OR',
    shortText: 'OR',
    shortTextCatgView: 'OR',
    objectType: 'operator',
  },
  NOT: {
    node: '',
    recType: ' ',
    keyword: 'NOT',
    shortText: 'NOT',
    shortTextCatgView: 'NOT',
    objectType: 'operator',
  },
  XOR: {
    node: '',
    recType: ' ',
    keyword: 'XOR',
    shortText: 'XOR',
    shortTextCatgView: 'XOR',
    objectType: 'operator',
  },
  AS: {
    node: '',
    recType: ' ',
    keyword: 'AS',
    shortText: 'AS',
    shortTextCatgView: 'AS',
    objectType: 'operator',
  },
  OPENING_BRACKET: {
    node: '',
    recType: ' ',
    keyword: '(',
    shortText: '(',
    shortTextCatgView: '(',
    objectType: 'operator',
  },
  CLOSING_BRACKET: {
    node: '',
    recType: ' ',
    keyword: ')',
    shortText: ')',
    shortTextCatgView: ')',
    objectType: 'operator',
  },
};

const LOGICAL_OPERATORS = [
  OPERATORS_MAP.AND.shortText,
  OPERATORS_MAP.OR.shortText,
  OPERATORS_MAP.XOR.shortText,
];

class SmartSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryDropdown: false,
      tagFocus: false,
      isDropdownFocus: false,
      tags: [],
      insight360_tags: [],
      insight360PersonalLabels: [],
      searchResults: [],
      expressionFormed: [],
      objectsAdded: [],
      selectedCategory: 'ALL',
      selectedCategoryID: '-1',
      inputSearchString: '',
      validExpression: true,
      tagSelectedEditIndex: -1,
      errorPosition: -1,
      errorMessage: '',
      selectedCategoryRecType: '',
      studyID: props.moduleStudy ? props.moduleStudy.st : '',
      definationTargetData: props.definationTarget
        ? props.definationTarget.data
        : [],
      definationTargetDataList: props.definationTargetList
        ? props.definationTargetList.data
        : [],
      error: {},
      geographySelectionArr: [
        'ALL',
        'U.S. Census Region',
        'State',
        'Market',
        'County',
        'Zip Codes',
      ],
      geographySmartSearch:
        this.props.geographySmartSearch !== undefined
          ? this.props.geographySmartSearch
          : [],
      isGeoDataPoint: false,
      selectedKeyword: '',
      popupApplyVisible: false,
      selectedCategoryQuestionID: '-1',
      selectedCategoryQuestionResults: [],
      inputId: `tag-input-box${
        this.props.uniqueIdName !== undefined
          ? `-${this.props.uniqueIdName}`
          : ''
      }`,
      smartSearchListId: `smart-search-list${
        this.props.uniqueIdName !== undefined
          ? `-${this.props.uniqueIdName}`
          : ''
      }`,
      inputClass: `reacttagsinput${
        this.props.uniqueIdName !== undefined
          ? `-${this.props.uniqueIdName}`
          : ''
      }`,
      isNCSNHCS: true,
      originalSearchResults: [],
      showToggleView: false,
      categoryListArr: [],
      instantEdgeAttrs: [],
      isSwitchClicked: false,
      isOperandSearch: false,
    };
    this.getSuggestions = _.debounce(this.getSuggestions, 300);
    this.categoryDropdownNode = React.createRef();
  }

  UNSAFE_componentWillMount() {
    if (this.props.allFeatures) {
      this.setState({
        isAutocodePresent: isAllFeaturePresent(
          AUTOCODE_ACCESS_ID,
          this.props.allFeatures
        ),
      });
    }
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.categoryDropdownButton)
      .getElementsByClassName('dropdown-toggle')[0]
      .setAttribute('title', this.state.selectedCategory);
    document.addEventListener('click', this.searchClick);
    this.handleSmartSearchSwitch();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.geographySmartSearch !== nextProps.geographySmartSearch) {
      this.setState(() => ({
        geographySmartSearch: nextProps.geographySmartSearch,
      }));
    }
    let selectedModule = nextProps.selectedModule
      ? nextProps.selectedModule.toLowerCase()
      : 'crosstab';
    selectedModule = selectedModule === 'visahaul' ? 'stories' : selectedModule;
    const moduleWeightType = `${selectedModule}WeightTypes`;
    if (
      nextProps[moduleWeightType] &&
      !_.isEqual(nextProps[moduleWeightType], this.props[moduleWeightType])
    ) {
      this.setState(
        {
          studyID: nextProps.moduleStudy.st,
          selectedCategory: 'ALL',
          selectedCategoryID: '-1',
          selectedCategoryRecType: '',
          selectedCategoryQuestionID: -1,
        },
        () => {
          this.updateExpression();
          this.getDataForSuggestionDropdowns(
            this.state.inputSearchString,
            this.props.selectedModule === 'MME' ||
              this.props.selectedModule === 'geo'
          );
        }
      );
    }
    if (
      nextProps.moduleStudy &&
      !_.isEqual(nextProps.moduleStudy, this.props.moduleStudy)
    ) {
      this.setState(
        {
          studyID: nextProps.moduleStudy.st,
          selectedCategory: 'ALL',
          selectedCategoryID: '-1',
          selectedCategoryRecType: '',
          selectedCategoryQuestionID: -1,
        },
        () => {
          this.updateExpression();
          this.getDataForSuggestionDropdowns(
            this.state.inputSearchString,
            this.props.selectedModule === 'MME' ||
              this.props.selectedModule === 'geo'
          );
        }
      );
      if (
        nextProps.moduleStudy &&
        nextProps.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
        this.props.selectedModule === CROSSTAB_CONSTANT
      ) {
        this.props.geographyActions.handleSearchGeographyTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          nextProps.moduleStudy.pn,
          { nodeId: 0, fname: null }
        );
        this.props.geographyActions.handleGeographySearch(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          nextProps.moduleStudy.pn
        );
      } else {
        this.props.selectedModule === CROSSTAB_CONSTANT &&
          this.props.geographyActions.clearGeographySmartSearchData();
      }
      this.setState(() => ({
        showToggleView: true,
      }));
    }

    /**
     * set a flag to hide and show sample weighted label on top of smart search
     */
    if (this.state.expressionFormed) {
      let geoDataCnt = 0;
      GEOGRAPHY_BASES.map(keyword => {
        this.state.expressionFormed.filter(exp => {
          if (exp && exp.includes(keyword)) {
            geoDataCnt += 1;
          }
          return exp;
        });
        return keyword;
      });
      if (geoDataCnt > 0) {
        this.setState(() => ({ isGeoDataPoint: true }));
      } else {
        this.setState(() => ({ isGeoDataPoint: false }));
      }
    }

    if (this.props.defination !== nextProps.defination) {
      this.setState({ defination: [...nextProps.defination] });
    }

    if (this.props.definationTarget !== nextProps.definationTarget) {
      this.setState(
        { definationTargetData: [...nextProps.definationTarget.data] },
        () => {
          if (
            this.state.definationTargetData &&
            this.state.definationTargetData.length > 0
          ) {
            // this.updateDifinationSearchResult(
            //   this.state.definationTargetData,
            //   this.state.selectedCategory,
            // );
            this.setTagFocus();
          }
        }
      );
    } else if (
      this.props.definationTargetList !== nextProps.definationTargetList
    ) {
      this.setState({
        definationTargetDataList: [...nextProps.definationTargetList.data],
      });
    }

    if (this.state.error !== nextProps.error) {
      this.setState({ error: nextProps.error });
    }

    if (
      this.props.resetInputInfo !== undefined &&
      !this.props.resetInputInfo &&
      nextProps.resetInputInfo
    ) {
      this.resetAll();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.searchClick);
  }

  handleSmartSearchSwitch = () => {
    if (this.props.moduleStudy) {
      this.setState(() => ({
        showToggleView: true,
      }));
    }
  };

  /**
   * Handle the tag input blur.
   */
  onTagInputBlur = e => {
    if (!e) {
      this.setState(
        prevState => ({ tagFocus: prevState.isDropdownFocus }),
        () => {
          if (this.state.tagFocus && this.tagsInput) {
            this.tagsInput.focus();
          }
        }
      );
    } else if (
      e.target.parentNode.getAttribute('data-inputid') === this.state.inputId ||
      e.target.getAttribute('data-listid') === this.state.smartSearchListId
    ) {
      this.setState(() => ({ tagFocus: true }));
      this.setTagFocus();
    }
  };

  /**
   * In Smart Search Category Dropdow, If a definition is selected
   * SuggestionBox will be triggered to fill with Definition Target Load
   * If Questions are selected, Suggestion Box will be triggered to fill
   * with Answers
   */
  onCategoryChange = (category, keyword, recType, uniqueId, pathId) => {
    let selectedCategoryID;
    if (pathId) {
      selectedCategoryID = pathId ? pathId.toString() : '-1';
    } else {
      selectedCategoryID = uniqueId ? uniqueId.toString() : '-1';
    }
    this.setState(
      {
        selectedCategory: category,
        selectedCategoryID,
        selectedCategoryRecType: recType,
        categoryDropdown: false,
        selectedDefinitionUniqId: uniqueId,
        selectedKeyword: keyword,
        categoryListArr: [],
        searchResults: [],
        originalSearchResults: [],
      },
      () => {
        ReactDOM.findDOMNode(this.categoryDropdownButton)
          .getElementsByClassName('dropdown-toggle')[0]
          .setAttribute('title', this.state.selectedCategory);

        // TODO: Can be optimized
        if (
          recType === 'Q' &&
          !(
            this.getLastObjectsType() === 'operand' ||
            this.getLastObjectsShortText() === ')' ||
            this.state.inputSearchString
          )
        ) {
          this.getAnswers();
          this.setState({ isDropdownFocus: true, definationTargetData: [] });
          this.setTagFocus();
        } else if (
          uniqueId &&
          recType === 'D' &&
          uniqueId !== '-1' &&
          !this.state.inputSearchString
        ) {
          // this.props.definitionActions.getDefinitionTargetLoad(
          //   this.props.activeAccountId,
          //   uniqueId,
          // );
          this.getDefinitions();
        } else {
          this.setState({ definationTargetData: [] });
          this.getDataForSuggestionDropdowns(
            this.state.inputSearchString,
            recType !== 'Q'
          );
        }
      }
    );
  };

  /**
   * DropDown Suggestion is filled based on various
   * If its Q - Answers are filled
   * It its Defenitions -  Definitions List
   * If the text box is blank or last added obj is operator show NOT operator
   * Geography - Geaography Search results
   * if none of the above- elastic search results are suggested
   */
  getDataForSuggestionDropdowns = (value, focusNotNeeded, isOnClick) => {
    if (this.getLastObjectsType() === 'operand') {
      if (this.isLastObjectHasChild()) {
        this.getChildrens(this.getLastObjectsNode());
      } else {
        this.getOperators(value);
      }
    } else if (
      this.getLastObjectsType() === 'operator' &&
      this.getLastObjectsShortText() === ')'
    ) {
      this.getOperatorsWithoutOpeningParenthesis(value);
    } else if (value === '(') {
      // Will only yield with 1 search result: '('
      this.getOperators(value);
      this.setState({ isOperandSearch: false });
    } else if (this.state.selectedCategoryRecType === 'Q') {
      if (value && value.length > 1 && !isOnClick) {
        this.getSuggestions(value);
        this.setState({ isDropdownFocus: true, isOperandSearch: false });
      } else {
        this.getAnswers();
      }
    } else if (
      this.state.selectedCategoryRecType === 'D' &&
      this.state.selectedCategory !== 'Definitions'
    ) {
      if (value && value.length > 1) {
        this.getSuggestions(value);
        this.setState({
          isDropdownFocus: true,
          isOperandSearch: false,
        });
      } else {
        this.getDefinitions();
      }
    } else if (
      // If the text box is blank or last added obj is operator show NOT operator.
      !value ||
      (value && value.length <= 1) ||
      ((!value || (value && value.length <= 1)) &&
        this.getLastObjectsType() === 'operator' &&
        this.getLastObjectsShortText() !== ')' &&
        this.getLastObjectsShortText() !== 'NOT')
    ) {
      // Will only yield with 1 search result: '('
      this.getNotAndParensOperators(value);
      this.setState({ isOperandSearch: false });
    } else if (this.state.selectedKeyword === 'IE') {
      if (value && value.length > 1 && !isOnClick) {
        this.getSuggestions(value);
        this.setState({ isDropdownFocus: true, isOperandSearch: false });
      }
    } else if (
      this.state.selectedCategory === 'Definitions' &&
      this.state.selectedCategoryID === '-1'
    ) {
      const dValue = value ? value.trim().toLowerCase() : '';
      const currentVal = this.state.inputSearchString
        ? this.state.inputSearchString.trim().toLowerCase()
        : '';
      if (currentVal === dValue && dValue.length >= 2) {
        this.getSuggestions(value);
        this.setState({ isDropdownFocus: true, isOperandSearch: false });
      }
    } else if (
      // if selected category is Geographies the get only the geography data
      this.state.selectedCategory === 'Geographies' &&
      this.state.selectedCategoryID === 'Geographies_Cat'
    ) {
      const dValue = value ? value.trim().toLowerCase() : '';
      const currentVal = this.state.inputSearchString
        ? this.state.inputSearchString.trim().toLowerCase()
        : '';
      let filterData = [];

      if (currentVal === dValue && dValue.length >= 2) {
        const inputStr = this.state.inputSearchString.toUpperCase();

        this.state.geographySmartSearch
          .filter(
            items =>
              items.a.includes(inputStr) ||
              (items.p !== null && items.p.includes(inputStr))
          )
          .map(items => filterData.push(items));

        filterData = this.updateGeographiesSearchResult_1(
          filterData,
          this.state.selectedCategory
        );
        this.newSmartSearchCategoryResults([], undefined, [], filterData);
        this.setState({
          searchResults: filterData,
          originalSearchResults: filterData,
          isDropdownFocus: true,
          isOperandSearch: false,
        });
      }
    } else if (!isOnClick) {
      this.getSuggestions(value);
    } else {
      this.setState({ isDropdownFocus: true, isOperandSearch: false });
    }

    if (!focusNotNeeded) {
      this.setTagFocus();
    }
  };

  handleElasticSearch = data => getSmartSearchData(data);

  /**
   * In the category Dropdown when ALL is selected.
   * search queries are passed to elastic search
   */
  getChildrens(node) {
    const attrField = [
      'id',
      'attr_name',
      'parent_attr_name',
      'parent_heirarchy',
      'keyword',
      'record_type',
      'record_tag',
      'study_dd',
      'path_id',
    ];
    const selectedCategoryID =
      this.state.selectedCategoryID === '-1'
        ? 'ALL'
        : this.state.selectedCategoryID;
    const matchQuery = {
      match: {
        parent_id_study_id_map: encodeQueryString(
          `${selectedCategoryID}_${this.state.studyID}`
        ),
      },
    };
    this.handleElasticSearch({
      body: this.getQueryForFolderAndQues(node, matchQuery, attrField),
    }).then(body => {
      this.updateSearchResults(body.hits);
    });
  }

  // forming the payload on selection of folders
  getQueryForFolderAndQues = (node, matchQuery, attrField) => {
    const ncsNHCSQuery = {
      query: {
        bool: {
          must: [
            {
              match: {
                studies: this.state.studyID,
              },
            },
            {
              match: {
                parent_id: node.node,
              },
            },
          ],
        },
      },
      size: urls.MAX_CHILDRENS,
      _source: attrField,
      attributes: {
        productNo: this.props.moduleStudy && this.props.moduleStudy.pn,
        accountId: this.props.activeAccountId,
        categorizeResults: false,
        includeHierarchy: true,
        sortSuggestions: false,
        customSort: false,
      },
    };
    return ncsNHCSQuery;
  };

  getAnswers(isOnClick, value) {
    let searchFilter = 'dict';
    if (this.state.selectedKeyword === 'IE') {
      searchFilter = 'tko';
    }
    const pathId = this.state.selectedCategoryID;
    const payload = {
      productNo: this.props.moduleStudy.pn,
      accountId: this.props.activeAccountId,
      searchText: value,
      studyId: this.state.studyID,
      studySourceId: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      searchFilter,
      pathId,
    };
    if (!isOnClick) {
      this.handleElasticSearch({
        body: payload,
      }).then(body => {
        this.updateSearchResults(body.data, undefined);
      });
    } else if (value.length < 2) {
      this.handleElasticSearch({
        body: payload,
      }).then(body => {
        this.updateSearchResults(body.hits, undefined);
      });
    }
  }

  getDefinitions = (isOnClick, value) => {
    const searchFilter = 'def';
    const pathId = this.state.selectedCategoryID;
    const payload = {
      productNo: this.props.moduleStudy.pn,
      accountId: this.props.activeAccountId,
      searchText: value,
      studyId: this.state.studyID,
      studySourceId: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      searchFilter,
      pathId,
    };
    if (!isOnClick) {
      this.handleElasticSearch({
        body: payload,
      }).then(body => {
        this.updateSearchResults(body.data, undefined);
        this.setState({
          tagFocus: true,
        });
        this.setTagFocus();
      });
    } else if (value.length < 2) {
      this.handleElasticSearch({
        body: payload,
      }).then(body => {
        this.updateSearchResults(body.data.dict.hits.hits, undefined);
      });
    }
  };

  getQueryForQuesInCategory = attrField => {
    const ncsNHCSQuery = {
      query: {
        bool: {
          must: [
            {
              match: {
                studies: this.state.studyID,
              },
            },
            {
              wildcard: {
                path_id: `${this.state.selectedCategoryID}.*`,
              },
            },
          ],
        },
      },
      size: urls.MAX_CHILDRENS,
      sort: this.getSortQueryForQuestions(),
      _source: attrField,
      attributes: {
        productNo: this.props.moduleStudy && this.props.moduleStudy.pn,
        accountId: this.props.activeAccountId,
        categorizeResults: false,
        includeHierarchy: true,
        sortSuggestions: false, // send true to get sorting from api
        customSort: false,
        includeCategories: true,
      },
    };
    return ncsNHCSQuery;
  };

  getSortQueryForQuestions = () => {
    return [
      {
        _script: {
          type: 'String',
          script: {
            source:
              "doc['attr_name.raw'].value.equalsIgnoreCase('YES') || doc['attr_name.raw'].value.equalsIgnoreCase('NO') || doc['attr_name.raw'].value.toUpperCase().startsWith('DON\\'T KNOW')|| doc['attr_name.raw'].value.toUpperCase().startsWith('NOT SURE') ? doc['parent_attr_name.raw'].value : '0'",
          },
          order: 'asc',
        },
      },
      {
        _script: {
          type: 'number',
          script: {
            source:
              "doc['attr_name.raw'].value.equalsIgnoreCase('YES') ? 9997 :doc['attr_name.raw'].value.equalsIgnoreCase('NO') ? 9998 : doc['attr_name.raw'].value.toUpperCase().startsWith('DON\\'T KNOW') ||  doc['attr_name.raw'].value.toUpperCase().startsWith('NOT SURE')? 9999 : 9996",
          },
          order: 'asc',
        },
      },
      {
        'attr_name.raw': {
          order: 'asc',
        },
      },
      {
        'parent_attr_name.raw': {
          order: 'asc',
        },
      },
    ];
  };

  getSuggestions(sValue) {
    const value = sValue ? sValue.trim().toLowerCase() : '';
    if (value.length >= 2) {
      let searchFilter = 'all';
      if (
        (this.state.selectedCategoryRecType === 'D' &&
          this.state.selectedCategory !== 'Definitions') ||
        this.state.selectedCategory === 'Definitions'
      ) {
        searchFilter = 'def';
      } else if (this.state.selectedKeyword === 'IE') {
        searchFilter = 'tko';
      } else if (
        ((this.state.selectedCategoryRecType === 'C' ||
          this.state.selectedCategoryRecType === 'S' ||
          this.state.selectedCategoryRecType === 'T') &&
          this.state.selectedCategory !== 'Dictionary') ||
        this.state.selectedCategory === 'Dictionary'
      ) {
        searchFilter = 'dict';
      } else if (this.state.selectedCategoryRecType === 'Q') {
        if (this.state.selectedKeyword === 'IE') {
          searchFilter = 'tko';
        } else {
          searchFilter = 'dict';
        }
      }
      const pathId =
        this.state.selectedCategoryID !== '-1'
          ? this.state.selectedCategoryID
          : undefined;

      const payload = {
        productNo: this.props.moduleStudy.pn,
        accountId: this.props.activeAccountId,
        searchText: value,
        studyId: this.state.studyID,
        studySourceId: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        searchFilter,
        pathId,
      };
      this.handleElasticSearch({
        body: payload,
      })
        .then(body => {
          const currentVal = this.state.inputSearchString
            ? this.state.inputSearchString.trim().toLowerCase()
            : '';
          if (currentVal === value) {
            this.updateSearchResults(body.data, value);
            if (
              body.hits !== undefined &&
              body.hits.hits !== undefined &&
              body.hits.hits.length === 0 &&
              this.state.inputSearchString !== ''
            ) {
              saveSearchTrackingData({
                uid: this.props.loginResponse.data.uid,
                accid: this.props.activeAccountId,
                productNo: this.props.moduleStudy.pn,
                moduleName:
                  this.props.dataScreen !== undefined
                    ? this.props.dataScreen
                    : 'Crosstab',
                subModule:
                  this.props.selectedTab !== undefined
                    ? this.props.selectedTab
                    : 'SMART SEARCH',
                textSearched: this.state.inputSearchString,
                textSelected: null,
                // detail: 'NO_MATCHED_RESULTS',
              });
            }
          }
        })
        .catch(err => {
          saveSearchTrackingData({
            uid: this.props.loginResponse.data.uid,
            accid: this.props.activeAccountId,
            productNo: this.props.moduleStudy.pn,
            moduleName:
              this.props.dataScreen !== undefined
                ? this.props.dataScreen
                : 'Crosstab',
            subModule:
              this.props.selectedTab !== undefined
                ? this.props.selectedTab
                : 'SMART SEARCH',
            textSearched: this.state.inputSearchString,
            textSelected: null,
            detail: err.message,
          });
          const currentVal = this.state.inputSearchString
            ? this.state.inputSearchString.trim().toLowerCase()
            : '';
          this.updateSearchResults([], value);
        });
    } else {
      this.setState({
        searchResults: [],
        originalSearchResults: [],
        categoryListArr: [],
      });
    }
  }

  getSmartSearchQueryBasedOnStudy = (
    value,
    matchQuery,
    attrField,
    wildcard,
    qtsType
  ) => {
    const regex = /(\s*)([^\w\s])(\s*)/gi;
    const trimmedString = value.replace(regex, '$2');
    const inputTxtArr = trimmedString.trim().toLowerCase().split(' ');
    let mustQuery = [];
    for (let i = 0; i < inputTxtArr.length; i += 1) {
      const prefixHeirarchyPayload = {
        prefix: {
          suggest_field_heirarchy: inputTxtArr[i],
        },
      };
      mustQuery[i] = prefixHeirarchyPayload;
    }
    mustQuery = [
      ...mustQuery,
      {
        match: {
          studies: this.state.studyID,
        },
      },
    ];
    // Query for Synonym based search
    // mustQuery = [
    //   {
    //     bool: {
    //       should: [
    //         {
    //           script: {
    //             script: {
    //               source: `def list = ${JSON.stringify(inputTxtArr)}; boolean getDoc = true; for(String x : list){ getDoc = getDoc && doc['suggest_field_heirarchy'].stream().anyMatch(s -> s.startsWith(x.toLowerCase())) }  return getDoc;`,
    //             },
    //           },
    //         },
    //         {
    //           match: {
    //             'suggest_field_heirarchy.raw': trimmedString.trim(),
    //           },
    //         },
    //       ],
    //     },
    //   },
    //   {
    //     match: {
    //       studies: this.state.studyID,
    //     },
    //   }];
    if (this.state.isNCSNHCS && qtsType === 'QTSTYPE') {
      mustQuery = [...mustQuery, matchQuery];
    } else if (wildcard) {
      mustQuery = [...mustQuery, wildcard];
    }

    const ncsNHCSQuery = {
      _source: attrField,
      query: {
        bool: {
          must: mustQuery,
        },
      },
      sort: this.getSortQuery(inputTxtArr, trimmedString),
      size: urls.MAX_RECORD_V3,
      attributes: {
        productNo: this.props.moduleStudy && this.props.moduleStudy.pn,
        accountId: this.props.activeAccountId,
        categorizeResults: false,
        searchText: value.trim().toLowerCase(),
        includeHierarchy: true,
        sortSuggestions: false, // send true to get sorting from api
        customSort: false,
        includeCategories: true,
      },
    };
    return ncsNHCSQuery;
  };

  getSortQuery = (inputArr, stringVal) => {
    return [
      {
        _script: {
          type: 'number',
          script: {
            source:
              "doc['record_tag'].value.equals('a') ? 1 :doc['record_tag'].value.equals('q') ? 2: 3 ",
          },
          order: 'asc',
        },
      },
      {
        _script: {
          type: 'number',
          script: {
            source: `def text = ${JSON.stringify(
              stringVal
            )};def list = ${JSON.stringify(
              inputArr
            )}; return doc['attr_name.raw'].value.equalsIgnoreCase(text) ? 4: doc['attr_name.raw'].value.toUpperCase().startsWith(text.toUpperCase()) ? 5: doc['attr_name.raw'].value.toUpperCase().contains(text.toUpperCase()) ? 6: list.stream().allMatch(s -> doc['attr_name.raw'].value.equalsIgnoreCase(s)) ? 7 : list.stream().allMatch(s -> doc['attr_name.raw'].value.toUpperCase().startsWith(s.toUpperCase())) ? 8 : list.stream().allMatch(s -> doc['attr_name.raw'].value.toUpperCase().contains(s.toUpperCase())) ? 9 : list.stream().anyMatch(s -> doc['attr_name.raw'].value.equalsIgnoreCase(s)) ? 10 : list.stream().anyMatch(s -> doc['attr_name.raw'].value.toUpperCase().startsWith(s.toUpperCase())) ? 11 : list.stream().anyMatch(s -> doc['attr_name.raw'].value.toUpperCase().contains(s.toUpperCase())) ? 12 : list.stream().anyMatch(s -> doc['parent_attr_name.raw'].value.equalsIgnoreCase(s)) ? 13 : list.stream().anyMatch(s -> doc['parent_attr_name.raw'].value.toUpperCase().startsWith(s.toUpperCase())) ? 14 : list.stream().anyMatch(s -> doc['parent_attr_name.raw'].value.toUpperCase().contains(s.toUpperCase())) ? 15 : 16`,
          },
          order: 'asc',
        },
      },
      {
        _script: {
          type: 'String',
          script: {
            source:
              "doc['attr_name.raw'].value.equalsIgnoreCase('YES') || doc['attr_name.raw'].value.equalsIgnoreCase('NO') || doc['attr_name.raw'].value.toUpperCase().startsWith('DON\\'T KNOW') || doc['attr_name.raw'].value.toUpperCase().startsWith('NOT SURE') ? doc['parent_attr_name.raw'].value : '0'",
          },
          order: 'asc',
        },
      },
      {
        _script: {
          type: 'number',
          script: {
            source:
              "doc['attr_name.raw'].value.equalsIgnoreCase('YES') ? 9995 :doc['attr_name.raw'].value.equalsIgnoreCase('NO') ? 9996 : doc['attr_name.raw'].value.toUpperCase().startsWith('DON\\'T KNOW') || doc['attr_name.raw'].value.toUpperCase().startsWith('NOT SURE')? 9997 : 9994",
          },
          order: 'asc',
        },
      },
      {
        'attr_name.raw': {
          order: 'asc',
        },
      },
      {
        'parent_attr_name.raw': {
          order: 'asc',
        },
      },
    ];
  };

  /**
   * Set the focus on the smart search text box
   */
  setTagFocus = () => {
    this.setState({ tagFocus: true });
    if (this.tagsInput) {
      this.tagsInput.focus();
    }
  };

  /**
   * gets the list of operators to be used after adding operand
   */
  getOperatorsWithoutOpeningParenthesis = sValue => {
    const { AND, OR, XOR, CLOSING_BRACKET } = OPERATORS_MAP;
    const value = sValue ? sValue.trim() : '';
    const operators = [AND, OR, XOR, CLOSING_BRACKET];
    const filteredOperatos = operators.filter(
      ({ shortText }) => shortText.includes(value.toUpperCase()) || value === ''
    );
    if (filteredOperatos.length === 0) {
      this.setState({
        searchResults: operators,
        originalSearchResults: operators,
        isOperandSearch: true,
      });
    } else {
      this.setState({
        searchResults: filteredOperatos,
        originalSearchResults: filteredOperatos,
        isOperandSearch: false,
      });
    }
  };

  /**
   * gets the list of operators to be used.
   */
  getOperators = sValue => {
    const { AND, OR, XOR, OPENING_BRACKET, CLOSING_BRACKET } = OPERATORS_MAP;
    const value = sValue ? sValue.trim() : '';
    const operators = [AND, OR, XOR, OPENING_BRACKET, CLOSING_BRACKET];
    const filteredOperatos = operators.filter(
      ({ shortText }) => shortText.includes(value.toUpperCase()) || value === ''
    );
    if (filteredOperatos.length === 0) {
      this.setState({
        searchResults: operators,
        originalSearchResults: operators,
        isOperandSearch: true,
      });
    } else {
      this.setState({
        searchResults: filteredOperatos,
        originalSearchResults: filteredOperatos,
        isOperandSearch: false,
      });
    }
  };

  /**
   * gets the list of operators to be used after adding operator or when it is blank
   */
  getNotAndParensOperators = sValue => {
    const { NOT, OPENING_BRACKET } = OPERATORS_MAP;
    const value = sValue ? sValue.trim() : '';
    this.setState({
      searchResults: [NOT, OPENING_BRACKET].filter(
        ({ shortText }) =>
          shortText === '(' || shortText === 'NOT' || value === ''
      ),
      categoryListArr: [],
    });
  };

  /**
   * get the last object added to smart search
   */
  getLastObject = objectsAdded => {
    const addedObjectList = objectsAdded || this.state.objectsAdded;
    const idx =
      this.state.tagSelectedEditIndex > -1
        ? this.state.tagSelectedEditIndex
        : addedObjectList.length;

    return idx < 1 ? {} : addedObjectList[idx - 1];
  };

  /**
   * Method to get the type of last node.
   */
  getLastObjectsType = objectsAdded =>
    this.getLastObject(objectsAdded).objectType;

  /**
   * Method to get the last node text.
   */
  getLastObjectsShortText = objectsAdded =>
    this.getLastObject(objectsAdded).shortText;

  /**
   * Method to get the last node.
   */
  getLastObjectsNode = objectsAdded => this.getLastObject(objectsAdded);

  /**
   * Method to handle Data Haul Run button.
   */
  handleRunDataHaul = () => {
    const {
      DataHaulBasesDataGrid,
      DataHaulColumnsDataGrid,
    } = this.props.gridData;
    if (DataHaulBasesDataGrid.length > 1) {
      this.modalDataHaulBaseWarining.show();
    } else if (DataHaulColumnsDataGrid.length > 10) {
      this.modalDataHaulColumnWarining.show();
    } else {
      this.props.runDataHaul();
    }
  };

  /**
   * Method to reset Sales Catalyst.
   */
  resetSalesCatalyst = () => {
    this.props.resetSalesCatalyst();
  };

  /**
   * Method to check if the last object has a child
   */
  isLastObjectHasChild = objectsAdded =>
    this.getLastObject(objectsAdded).recType === 'H';

  /**
   * format simmons data to be shown in the custom dropdown
   */
  formatSuggestion = option => {
    let shortTextPrifix = option._source.record_tag.toUpperCase();
    if (
      shortTextPrifix === 'C' ||
      shortTextPrifix === 'S' ||
      shortTextPrifix === 'T'
    ) {
      shortTextPrifix = 'F';
    }
    if (
      option._source.study_dd &&
      option._source.study_dd.indexOf(this.props.study.crosstabStudy.study) !==
        -1 &&
      (option._source.record_tag === 'a' || option._source.record_tag === 'ad')
    ) {
      return {
        node: option._id,
        recType: option._source.record_type,
        recordTag: option._source.record_tag.toUpperCase(),
        keyword: option._source.keyword,
        shortText: `${option._source.attr_name}${
          option._source.parent_attr_name.length > 0
            ? ` (${option._source.parent_attr_name})`
            : ''
        }`,
        objectType: 'operand',
        sortText:
          option._source.parent_attr_name.length > 0
            ? `${option._source.attr_name} (${option._source.parent_attr_name})`
            : option._source.attr_name,
        shortTextPrifix,
        ddNHCS: true,
        ddNHCSText: `${String.fromCharCode(10020)} ${option._source.attr_name}${
          option._source.parent_attr_name.length > 0
            ? ` (${option._source.parent_attr_name})`
            : ''
        }`,
        selectedStudy: this.props.study.crosstabStudy.st,
        selectedStudyDesc: this.props.study.crosstabStudy.sd,
        prop_code: option._source.prop_code,
        propCodeType: option.propCodeType,
        pathId: option._source.path_id,
        breadcrumbs:
          option.propCodeType === 'IE'
            ? `Turn-Key Omnibus > ${option._source.parent_hierarchy.replace(
                /\|\|/g,
                ' > '
              )}`
            : option._source.parent_hierarchy.replace(/\|\|/g, ' > '),
      };
    }
    return {
      node: option._id,
      recType: option._source.record_type,
      recordTag: option._source.record_tag.toUpperCase(),
      keyword: option._source.keyword,
      shortText: `${option._source.attr_name}${
        option._source.parent_attr_name.length > 0
          ? ` (${option._source.parent_attr_name})`
          : ''
      }`,
      objectType: 'operand',
      sortText:
        option._source.parent_attr_name.length > 0
          ? `${option._source.attr_name} (${option._source.parent_attr_name})`
          : option._source.attr_name,
      shortTextPrifix,
      selectedStudy: this.props.study.crosstabStudy.st,
      selectedStudyDesc: this.props.study.crosstabStudy.sd,
      prop_code: option._source.prop_code,
      propCodeType: option.propCodeType,
      pathId: option._source.path_id,
      breadcrumbs:
        option.propCodeType === 'IE'
          ? `Turn-Key Omnibus > ${option._source.parent_hierarchy.replace(
              /\|\|/g,
              ' > '
            )}`
          : option._source.parent_hierarchy.replace(/\|\|/g, ' > '),
    };
  };

  /**
   * format QTS suggestions
   */

  formatQTSSuggestion = (option, category) => {
    const shortTextPrifix = 'IE';
    if (
      category === 'ALL' ||
      (category === 'Definitions' && option.definitionName)
    ) {
      return {
        node: option._source.id,
        recType: option._source.record_type,
        recordTag: option._source.record_tag.toUpperCase(),
        keyword: option._source.keyword,
        shortText: option._source.attr_name,
        shortTextCatgView: option._source.attr_name,
        objectType: 'operand',
        sortText: `${option._source.attr_name}`,
        shortTextPrifix,
        shortText_Insight360: `${option._source.attr_name}`,
        breadcrumbs: `Turn-Key Omnibus > ${option._source.parent_hierarchy.replace(
          /\|\|/g,
          ' > '
        )}`,
        pathId: option._source.path_id,
      };
    }
    return {
      node: option._source.id,
      recType: option._source.record_type,
      recordTag: option._source.record_tag.toUpperCase(),
      keyword: option._source.keyword,
      shortText: option._source.attr_name,
      shortTextCatgView: option._source.attr_name,
      objectType: 'operand',
      sortText: `${option._source.attr_name}`,
      shortTextPrifix,
      shortText_Insight360: ` ${option._source.attr_name}`,
      breadcrumbs: `Turn-Key Omnibus > ${option._source.parent_hierarchy.replace(
        /\|\|/g,
        ' > '
      )}`,
      pathId: option._source.path_id,
    };
  };

  /**
   * format definition data to be shown in the custom dropdown
   */
  formatDefinitionSuggestion = (option, category) => {
    const shortTextPrifix = 'D';
    if (
      category === 'ALL' ||
      (category === 'Definitions' && option.definitionName)
    ) {
      return {
        node: option._source.id,
        recType: 'D',
        recordTag: 'D',
        keyword: option._source.keyword,
        shortText: option._source.attr_name,
        shortTextCatgView: option._source.attr_name,
        objectType: 'operand',
        sortText: `${option._source.attr_name}`,
        shortTextPrifix,
        shortText_Insight360: `${option._source.attr_name}`,
        breadcrumbs: `Definitions > ${option._source.parent_attr_name}`,
        pathId: option._source.path_id,
        title: `${option._source.attr_name}`,
      };
    }
    return {
      node: option._source.id,
      recType: 'D',
      recordTag: 'D',
      keyword: option._source.keyword,
      shortText: option._source.attr_name,
      shortTextCatgView: option._source.attr_name,
      objectType: 'operand',
      sortText: `${option._source.attr_name}`,
      shortTextPrifix,
      shortText_Insight360: ` ${option._source.attr_name}`,
      breadcrumbs: `Definitions > ${option._source.parent_attr_name}`,
      pathId: option._source.path_id,
      title: `${option._source.attr_name}`,
    };
  };

  /**
   * format geographies data to be shown in the custom dropdown
   */
  formatGeographiesSuggestion = (option, category) => {
    const shortTextPrifix = 'G';
    const parent = option.p !== null ? option.p : '';
    if (category === 'ALL' || (category === 'Geographies' && option.a)) {
      return {
        node: option.i,
        recType: 'G',
        recordTag: 'G',
        shortText: option.a,
        shortTextCatgView: option.a,
        objectType: 'operand',
        sortText: option.a,
        shortTextPrifix,
        keyword: '',
        scope: '',
        category: option.c === 'ZIPCODE' ? 'ZIP' : option.c,
        breadcrumbs: parent
          ? `Geographies > ${parent} > ${option.c}`
          : `Geographies > ${option.c}`,
        pathId: option.c,
      };
    }
    return {
      node: option.i,
      recType: 'G',
      recordTag: 'G',
      shortText: option.a,
      shortTextCatgView: option.a,
      objectType: 'operand',
      sortText: option.a,
      shortTextPrifix,
      keyword: '',
      scope: '',
      category: option.c === 'ZIPCODE' ? 'ZIP' : option.c,
      breadcrumbs: parent
        ? `Geographies > ${parent} > ${option.c}`
        : `Geographies > ${option.c}`,
      pathId: option.c,
    };
  };

  /**
   * Method to check if the study Id present in the propcode list for the data point
   */
  doesPropCodeListContainsStudyID(propCodeList) {
    let studyFlag = false;
    const breakException = {};
    try {
      propCodeList.forEach(propCode => {
        if (propCode.startsWith(this.state.studyID)) {
          studyFlag = true;
          throw breakException;
        }
      });
    } catch (e) {
      if (e !== breakException) throw e;
    }

    return studyFlag;
  }

  /**
   * sort the suggestion based on exact match and then partial match and so on.
   */
  customSortSuggestions = (suggestions, mquery) => {
    if (mquery) {
      const equalsQuery = [];
      const startsWithQuery = [];
      const containsQuery = [];
      const restAllQuery = [];
      let sortedArray = [];
      const query = mquery.toUpperCase();

      suggestions.forEach(suggestion => {
        if (suggestion.sortText.toUpperCase() === query) {
          equalsQuery.push(suggestion);
        } else if (suggestion.sortText.toUpperCase().startsWith(query)) {
          startsWithQuery.push(suggestion);
        } else if (suggestion.sortText.toUpperCase().includes(query)) {
          containsQuery.push(suggestion);
        } else {
          restAllQuery.push(suggestion);
        }
      });

      if (startsWithQuery.length > 0) {
        startsWithQuery.sort((v1, v2) => compareStrings(v1, v2));
      }

      if (containsQuery.length > 0) {
        containsQuery.sort((v1, v2) => compareStrings(v1, v2));
      }

      if (restAllQuery.length > 0) {
        restAllQuery.sort((v1, v2) => compareStrings(v1, v2));
      }

      sortedArray = equalsQuery.concat(startsWithQuery);
      sortedArray = sortedArray.concat(containsQuery);
      sortedArray = sortedArray.concat(restAllQuery);

      if (sortedArray.length === 0) {
        suggestions.sort((v1, v2) => compareStrings(v1, v2));
        return suggestions;
      }
      return sortedArray;
    }

    suggestions.sort((v1, v2) => compareStrings(v1, v2));
    return suggestions;
  };

  /**
   * Method to update Geographical search results
   */
  updateGeographiesSearchResult_1(options, category) {
    const searchResults = [];
    options.forEach(option => {
      searchResults.push(this.formatGeographiesSuggestion(option, category));
    });
    return searchResults;
  }

  /**
   * New View Smart Search result iteration.
   */
  newSmartSearchCategoryResults = (
    resultData,
    data,
    filterData,
    geographyData
  ) => {
    const heirarchyArr = [];
    const pathIdArr = [];
    const dataTypeArr = [];
    const dictCategories = data && data.dict ? data.dict.hits.categories : [];
    const defCategories = data && data.def ? data.def.hits.categories : [];
    const qtsCategories = data && data.tko ? data.tko.hits.categories : [];
    let categoryListArr = [];
    _.forEach(geographyData, data => {
      if (data.breadcrumbs) {
        const breadcrumbs = `Geographies - ${data.pathId}`;
        heirarchyArr.push(breadcrumbs.split(' > '));
        const pathId = data.pathId;
        pathIdArr.push(pathId.split('.'));
        dataTypeArr.push('G');
      }
    });
    categoryListArr = [...dictCategories];
    if (heirarchyArr.length > 0 || categoryListArr) {
      _.forEach(
        _.zipWith(
          heirarchyArr,
          pathIdArr,
          dataTypeArr,
          (heirarchyArr, pathIdArr, dataTypeArr) => ({
            heirarchyArr,
            pathIdArr,
            dataTypeArr,
          })
        ),
        result => {
          categoryListArr = this.categoryResultCretaion(
            result,
            categoryListArr
          );
        }
      );
      const updatedDefCategories = defCategories.map(option => ({
        ...option,
        name: `Definitions - ${option.name}`,
      }));
      categoryListArr = [
        ...categoryListArr,
        ...updatedDefCategories,
        ...qtsCategories,
      ];
      this.setState({ categoryListArr });
    } else {
      this.setState({ categoryListArr: [] });
    }
  };

  categoryResultCretaion = (result, categoryListArr) => {
    _.forEach(result.heirarchyArr, (data, index) => {
      if (index === 0) {
        // const objectKeys = Object.keys(categoryListArr);
        const isCatgAlreadyExist = categoryListArr.some(
          catg => catg.name === result.heirarchyArr[index]
        );
        if (!isCatgAlreadyExist) {
          categoryListArr = [
            ...categoryListArr,
            {
              name: result.heirarchyArr[index],
              pathId: result.pathIdArr[index].toString(),
              type: result.dataTypeArr[index],
            },
          ];
        }
      } else {
        let extractObj = {};
        for (let tempVar = 0; tempVar < index; tempVar++) {
          if (tempVar === 0) {
            extractObj = categoryListArr[result.heirarchyArr[tempVar]];
          } else {
            extractObj = extractObj[result.heirarchyArr[tempVar]];
          }
        }
        const keyArr = Object.keys(extractObj);
        if (!keyArr.includes(result.heirarchyArr[index])) {
          extractObj[result.heirarchyArr[index]] = {
            pathId: result.pathIdArr.slice(0, index + 1).join('.'),
          };
        }
      }
    });
    return categoryListArr;
  };

  /**
   * format simmons data to be shown in the custom dropdown
   */
  categorizedFormatSuggestion = option => {
    let shortTextPrifix = option._source.record_tag.toUpperCase();
    if (
      shortTextPrifix === 'C' ||
      shortTextPrifix === 'S' ||
      shortTextPrifix === 'T'
    ) {
      shortTextPrifix = 'F';
    }
    return {
      node: option._id,
      recType: option._source.record_type,
      recordTag: option._source.record_tag.toUpperCase(),
      keyword: option._source.keyword,
      shortText: `${
        option._source.parent_attr_name.length > 0
          ? `${option._source.parent_attr_name}: `
          : ''
      }${option._source.attr_name}`,
      shortTextCatgView: option._source.attr_name,
      objectType: 'operand',
      sortText: option._source.attr_name,
      shortTextPrifix,
      selectedStudy: this.props.study.crosstabStudy.st,
      selectedStudyDesc: this.props.study.crosstabStudy.sd,
      propCodeType: option.propCodeType,
      breadcrumbs:
        option.propCodeType === 'IE'
          ? `Turn-Key Omnibus > ${option._source.parent_hierarchy.replace(
              /\|\|/g,
              ' > '
            )}`
          : option._source.parent_hierarchy.replace(/\|\|/g, ' > '),
      pathId: option._source.path_id,
    };
  };

  onSelectCategory = selectedCategoriesId => {
    let searchResults = [];
    if (selectedCategoriesId.length > 0) {
      selectedCategoriesId.forEach(categoryId => {
        searchResults = [
          ...searchResults,
          ...this.state.originalSearchResults.filter(
            option => option.pathId && option.pathId.includes(categoryId)
          ),
        ];
      });
      const simmonsSearchResults = [];
      const defSearchResults = [];
      const qtsSearchResults = [];
      const geoSearchResults = [];
      searchResults.forEach(data => {
        if (data.recType === 'D') {
          defSearchResults.push(data);
        } else if (data.recType === 'G') {
          geoSearchResults.push(data);
        } else {
          data.propCodeType
            ? qtsSearchResults.push(data)
            : simmonsSearchResults.push(data);
        }
      });
      const simmonsSortData = this.customSortSuggestions(
        simmonsSearchResults,
        this.state.inputSearchString
      );
      const defSortData = this.customSortSuggestions(
        defSearchResults,
        this.state.inputSearchString
      );
      const qtsSortData = this.customSortSuggestions(
        qtsSearchResults,
        this.state.inputSearchString
      );
      const geoSortData = this.customSortSuggestions(
        geoSearchResults,
        this.state.inputSearchString
      );
      let sortedSearchResults = [];
      sortedSearchResults = sortedSearchResults
        .concat(simmonsSortData)
        .concat(geoSortData)
        .concat(defSortData)
        .concat(qtsSortData);
      this.setState(() => ({ searchResults: sortedSearchResults }));
    } else {
      this.setState(() => ({
        searchResults: this.state.originalSearchResults,
      }));
    }
  };

  updateSearchResults(data, query) {
    const dictionaryData = data.dict;
    const dictionaryOptions = dictionaryData ? dictionaryData.hits.hits : [];
    const definitionData = data.def;
    const definitionOptions = definitionData ? definitionData.hits.hits : [];
    const qtsData = data.tko;
    const qtsOptions = qtsData ? qtsData.hits.hits : [];
    const searchResults = [];
    const definitionResults = [];
    const qtsResults = [];
    dictionaryOptions.forEach(option => {
      if (option._source.record_tag === 'a') {
        searchResults.push(this.categorizedFormatSuggestion(option));
      }
    });
    if (definitionOptions && definitionOptions.length > 0) {
      definitionOptions.forEach(def => {
        if (def._source.record_tag === 'a') {
          definitionResults.push(
            this.formatDefinitionSuggestion(def, this.state.selectedCategory)
          );
        }
      });
    }
    if (qtsOptions && qtsOptions.length > 0) {
      qtsOptions.forEach(option => {
        if (option._source.record_tag === 'a')
          qtsResults.push(this.formatQTSSuggestion(option));
      });
    }
    const geographyData =
      this.props.moduleStudy &&
      this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
      this.props.selectedModule === CROSSTAB_CONSTANT &&
      this.state.geographySelectionArr.indexOf(this.state.selectedCategory) !==
        -1
        ? this.updateGeographicalSearchResults()
        : [];

    this.percentageCombination(
      searchResults,
      definitionResults,
      qtsResults,
      geographyData,
      data
    );
  }

  filterQtsDataFromSimmonsData = data => {
    const simmonsData = [];
    const qtsData = [];
    _.map(data, item => {
      if (item.propCodeType) {
        qtsData.push(item);
      } else {
        simmonsData.push(item);
      }
    });
    return { simmonsData, qtsData };
  };

  /**
   * Method to handle Geographical search results.
   */
  updateGeographicalSearchResults() {
    const currentVal = this.state.inputSearchString
      ? this.state.inputSearchString.trim().toLowerCase()
      : '';
    let geographyData = [];

    if (currentVal.length >= 2) {
      const inputStr = this.state.inputSearchString
        .toUpperCase()
        .split(/\s+|-/g);

      switch (this.state.selectedCategory) {
        case 'U.S. Census Region': {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (
                    !(
                      dataArr[j].toUpperCase().startsWith(inputStr[i]) &&
                      items.c === 'REGION'
                    )
                  ) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
          break;
        }
        case 'State': {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (
                    !(
                      dataArr[j].toUpperCase().startsWith(inputStr[i]) &&
                      items.c === 'STATE'
                    )
                  ) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
          break;
        }
        case 'Market': {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (
                    !(
                      dataArr[j].toUpperCase().startsWith(inputStr[i]) &&
                      items.c === 'MARKET'
                    )
                  ) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
          break;
        }
        case 'County': {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (
                    !(
                      dataArr[j].toUpperCase().startsWith(inputStr[i]) &&
                      items.c === 'COUNTY'
                    )
                  ) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
          break;
        }
        case 'Zip Codes': {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (
                    !(
                      dataArr[j].toUpperCase().startsWith(inputStr[i]) &&
                      items.c === 'ZIPCODE'
                    )
                  ) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
          break;
        }
        default: {
          this.state.geographySmartSearch
            .filter(items => {
              const completeStr = `${items.a} ${items.p}`;
              const dataArr = completeStr.toUpperCase().split(' ');
              let isPresent = true;
              for (let i = 0; i < inputStr.length; i += 1) {
                if (!isPresent) break;
                for (let j = 0; j < dataArr.length; j += 1) {
                  if (!dataArr[j].toUpperCase().startsWith(inputStr[i])) {
                    isPresent = false;
                  } else {
                    isPresent = true;
                    break;
                  }
                }
              }
              return isPresent;
            })
            .map(items => geographyData.push(items));
        }
      }

      geographyData = this.updateGeographiesSearchResult_1(
        geographyData,
        this.state.selectedCategory
      );
    }

    return geographyData;
  }

  /*
   * Amount of data to be shown in smart search custom dropdown
   * If data % is less than 100, then display all
   */

  percentageCalc = (data, pctg) => {
    let calculatedRecords = data.length;
    if (data.length > 100) {
      calculatedRecords = Math.ceil((data.length * pctg) / 100);
    }
    return calculatedRecords;
  };

  /**
   * % combination Data logic for data to be shown in custom dropdown
   * whichever data is not present adjust the share of that with simmons data
   */

  // percentageCombination(simmonsData, definitionData, qtsData, geographyData, categories) {
  //   const finalArr = [];
  //   let simmonsPctg = 70;
  //   let geographyPctg = 10;
  //   let qtsPctg = 10;
  //   let definitionPctg = 10;
  //   let minionsCount = 3; // minionsCount  is the count of records having 10% margin.

  //   if (geographyData === undefined || geographyData.length === 0) {
  //     geographyPctg = 0;
  //     minionsCount -= 1;
  //   }
  //   if (qtsData === undefined || qtsData.length === 0) {
  //     qtsPctg = 0;
  //     minionsCount -= 1;
  //   }
  //   if (definitionData === undefined || definitionData.length === 0) {
  //     definitionPctg = 0;
  //     minionsCount -= 1;
  //   }

  //   if (simmonsData && simmonsData.length === 0) {
  //     simmonsPctg = 0;
  //     definitionPctg = definitionPctg !== 0 ? 100 / minionsCount : 0;
  //     qtsPctg = qtsPctg !== 0 ? 100 / minionsCount : 0;
  //     geographyPctg = geographyPctg !== 0 ? 100 / minionsCount : 0;
  //   } else if (minionsCount === 0) {
  //       simmonsPctg = 100;
  //     } else if (minionsCount < 3) {
  //       definitionPctg = definitionPctg !== 0 ? 30 / minionsCount : 0;
  //       qtsPctg = qtsPctg !== 0 ? 30 / minionsCount : 0;
  //       geographyPctg = geographyPctg !== 0 ? 30 / minionsCount : 0;
  //     }
  //   if (simmonsData) {
  //     simmonsData
  //       .slice(0, this.percentageCalc(simmonsData, simmonsPctg))
  //       .map(items => finalArr.push(items));
  //   }
  //   if (geographyData) {
  //     geographyData
  //       .slice(0, this.percentageCalc(geographyData, geographyPctg))
  //       .map(items => finalArr.push(items));
  //   }
  //   if (definitionData) {
  //     definitionData
  //       .slice(0, this.percentageCalc(definitionData, definitionPctg))
  //       .map(items => finalArr.push(items));
  //   }

  //   if (qtsData) {
  //     qtsData
  //       .slice(0, this.percentageCalc(qtsData, qtsPctg))
  //       .map(items => finalArr.push(items));
  //   }
  //   this.newSmartSearchCategoryResults(finalArr.filter(item => {
  //     return item.recordTag === 'A';
  //   }), categories, definitionData, geographyData);
  //   this.setState({ searchResults: finalArr, originalSearchResults: finalArr });
  // }

  percentageCombination(
    simmonsData,
    definitionData,
    qtsData,
    geographyData,
    data
  ) {
    let finalArr = [];

    if (geographyData.length > 1500) {
      geographyData.slice(0, 1500).map(items => finalArr.push(items));
    }

    finalArr = [
      ...simmonsData,
      ...geographyData,
      ...definitionData,
      ...qtsData,
    ];

    this.newSmartSearchCategoryResults(
      finalArr.filter(item => {
        return item.recordTag === 'A';
      }),
      data,
      definitionData,
      geographyData
    );
    this.setState({ searchResults: finalArr, originalSearchResults: finalArr });
  }

  /**
   * validate the smart search expression after selection the data point from the dropdown
   */
  updateExpression = () => {
    if (this.state.objectsAdded && this.state.objectsAdded.length > 0) {
      const expressions = [];
      const kpiExpression = {};
      this.state.objectsAdded.forEach(tag => {
        if (tag.objectType === 'operand') {
          if (tag.recType !== 'H') {
            expressions.push(tag.keyword);
            kpiExpression[tag.keyword] = tag.shortText;
          }
        } else if (tag.objectType === 'operator') {
          if (tag.shortText !== 'AS') {
            expressions.push(tag.keyword);
            kpiExpression[tag.keyword] = tag.shortText;
          }
        }
      });
      if (this.props.removeKPI !== undefined) {
        this.props.removeKPI();
      }
      this.props.gridData.kpiInfo = undefined;
      this.setState({ expressionFormed: expressions }, () =>
        this.validateParenthesis(expressions, kpiExpression)
      );
    }
  };

  /**
   * Handle the removal of input tag in smart search expression
   */
  handleRemoveTagsInput = removeIndex => {
    const objAdd = this.state.objectsAdded;
    const expAdd = this.state.expressionFormed;
    const tags = this.state.tags;
    const insight360_tags = _.clone(this.state.insight360_tags);
    const insight360PersonalLabels = this.state.insight360PersonalLabels;
    objAdd.splice(removeIndex, 1);
    expAdd.splice(removeIndex, 1);
    tags.splice(removeIndex, 1);
    insight360PersonalLabels.splice(removeIndex, 1);
    insight360_tags.splice(removeIndex, 1);
    if (tags.length) {
      this.setState(
        {
          objectsAdded: objAdd,
          expressionFormed: expAdd,
          tags,
          insight360_tags,
          insight360PersonalLabels,
        },
        () => {
          const removeIdx =
            this.state.tags.length - 1 < removeIndex ? -1 : removeIndex;
          this.tagsInput.doSetEditIndex(removeIdx, () => {
            this.updateExpression();
            this.getDataForSuggestionDropdowns();
          });
        }
      );
    } else {
      this.tagsInput.doSetEditIndex(-1);
      if (this.props.getLatestExpression) {
        this.props.getLatestExpression([], false);
      }
      if (this.props.removeKPI !== undefined) {
        this.props.removeKPI();
      }
      if (this.props.handleRemoveTags !== undefined) {
        this.props.handleRemoveTags();
      }
      this.setState({ validExpression: true, tagFocus: true });
      this.setTagFocus();
    }
  };

  handleSelectedIndexState = () => {
    this.tagsInput.doSetEditIndex(-1);
  };

  /**
   * Handle the smart search input text changes
   */
  handleChangeInput = value => {
    this.setState({ inputSearchString: value }, () => {
      this.getDataForSuggestionDropdowns(this.state.inputSearchString);
    });
  };

  /**
   * Method to handle the selection of single or datapoints from the custom dropdown
   */
  handleSelect = (value, operation) => {
    if (this.state.inputSearchString !== '') {
      let selectedText = '';
      _.each(value, (node, i) => {
        const shortText = node.shortTextCatgView;
        selectedText += shortText + (i === value.length - 1 ? '' : ' * ');
      });
      saveSearchTrackingData({
        uid: this.props.loginResponse.data.uid,
        accid: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        moduleName:
          this.props.dataScreen !== undefined
            ? this.props.dataScreen
            : 'Crosstab',
        subModule:
          this.props.selectedTab !== undefined
            ? this.props.selectedTab
            : 'SMART SEARCH',
        textSearched: this.state.inputSearchString,
        textSelected: selectedText,
      });
    }

    if (
      operation === 'RowsDataGrid' ||
      operation === 'ColumnsDataGrid' ||
      operation === 'BasesDataGrid' ||
      operation === 'TargetDataGrid' ||
      operation === 'TargetsDataGrid' ||
      operation === 'BaseDataGrid' ||
      operation === 'DataHaulColumnsDataGrid' ||
      operation === 'DataHaulBasesDataGrid'
    ) {
      if (
        this.props.selectedModule === MME_MODULE &&
        this.props.gridData.TargetsDataGrid.length + value.length >
          urls.MME_TARGET_COUNT &&
        operation === 'TargetsDataGrid'
      ) {
        this.targetMaxLimitModal.show();
      } else {
        this.handleMultipleMove(value, operation);
        this.props.selectedModule === MME_MODULE &&
        this.props.isEnableMMEViewer &&
        operation === 'TargetsDataGrid'
          ? this.runReportModal.show()
          : '';
      }
    } else {
      let objsAdded = this.state.objectsAdded;
      let tags = this.state.tags;
      let insight360_tags = this.state.insight360_tags;
      let insight360PersonalLabels = this.state.insight360PersonalLabels;

      if (operation === null) {
        if (this.state.tagSelectedEditIndex > -1) {
          tags.splice(
            this.state.tagSelectedEditIndex,
            0,
            value[0].shortTextCatgView
          );
          insight360_tags.splice(
            this.state.tagSelectedEditIndex,
            0,
            value[0].shortText_Insight360
          );
          insight360PersonalLabels.splice(
            this.state.tagSelectedEditIndex,
            0,
            value[0].shortText
          );
          objsAdded.splice(this.state.tagSelectedEditIndex, 0, value[0]);
        } else {
          tags.push(value[0].shortTextCatgView);
          insight360_tags.push(value[0].shortText_Insight360);
          insight360PersonalLabels.push(value[0].shortText);
          objsAdded.push(value[0]);
        }
      } else {
        const tempTags = [];
        const tempObjsAdded = [];
        for (let index = 0; index < value.length; index += 1) {
          if (index > 0) {
            if (operation === OPERATORS_MAP.AND.shortText) {
              tempTags.push(OPERATORS_MAP.AND.shortText);
              tempObjsAdded.push(OPERATORS_MAP.AND);
            } else if (operation === OPERATORS_MAP.OR.shortText) {
              tempTags.push(OPERATORS_MAP.OR.shortText);
              tempObjsAdded.push(OPERATORS_MAP.OR);
            }
          }
          tempTags.push(value[index].shortText);
          tempObjsAdded.push(value[index]);
        }

        tempTags.splice(0, 0, OPERATORS_MAP.OPENING_BRACKET.shortText);
        tempTags.splice(
          tempTags.length,
          0,
          OPERATORS_MAP.CLOSING_BRACKET.shortText
        );
        tempObjsAdded.splice(0, 0, OPERATORS_MAP.OPENING_BRACKET);
        tempObjsAdded.splice(tempTags.length, 0, OPERATORS_MAP.CLOSING_BRACKET);

        if (this.state.tagSelectedEditIndex > -1) {
          tags.splice(this.state.tagSelectedEditIndex, 0, ...tempTags);
          insight360_tags.splice(
            this.state.tagSelectedEditIndex,
            0,
            ...tempTags
          );
          insight360PersonalLabels.splice(
            this.state.tagSelectedEditIndex,
            0,
            ...tempTags
          );
          objsAdded.splice(
            this.state.tagSelectedEditIndex,
            0,
            ...tempObjsAdded
          );
        } else {
          tags = [...tags, ...tempTags];
          insight360_tags = [...insight360_tags, ...tempTags];
          insight360PersonalLabels = [...insight360PersonalLabels, ...tempTags];
          objsAdded = [...objsAdded, ...tempObjsAdded];
        }
      }

      if (value[0].recType !== 'H') {
        const tmpTags = [...tags];
        const tmpinsight360_Tags = [...insight360_tags];
        const tmpObjsAdded = [...objsAdded];
        tags = [];
        insight360_tags = [];
        objsAdded = [];
        tmpObjsAdded.map((node, index) => {
          if (node.recType !== 'H') {
            tags.push(tmpTags[index]);
            insight360_tags.push(tmpinsight360_Tags[index]);
            objsAdded.push(node);
          }
          return true;
        });
      }

      this.setState(
        {
          tags,
          objectsAdded: objsAdded,
          inputSearchString: '',
          tagSelectedEditIndex: -1,
          searchResults: [],
          insight360_tags,
          insight360PersonalLabels,
          categoryListArr: [],
          originalSearchResults: [],
        },
        () => {
          this.tagsInput.doSetEditIndex(this.state.tagSelectedEditIndex, () => {
            this.updateExpression();
            this.getDataForSuggestionDropdowns();
          });
        }
      );
    }
  };

  /**
   * Method to validate the operators position in the expression
   */
  isValidOperatorsBetweenOperands = () => {
    const addedObjects = this.state.objectsAdded;
    let shortText;
    for (let index = 0; index < addedObjects.length; index += 1) {
      if (addedObjects[index].objectType === 'operand') {
        if (addedObjects[index].recType !== 'H') {
          if (index + 1 < addedObjects.length) {
            if (addedObjects[index + 1].objectType === 'operator') {
              shortText = addedObjects[index + 1].shortText;
              if (
                shortText === 'AND' ||
                shortText === 'OR' ||
                shortText === 'NOT' ||
                shortText === 'XOR' ||
                shortText === 'AS' ||
                shortText === ')'
              ) {
                if (this.state.validExpression === false) {
                  this.setState(
                    {
                      validExpression: true,
                      errorMessage: '',
                    },
                    () => {
                      if (this.props.getLatestExpression) {
                        this.props.getLatestExpression(
                          this.state.expressionFormed,
                          true
                        );
                      }
                    }
                  );
                }
              } else {
                this.setState(
                  {
                    errorPosition: index,
                    validExpression: false,
                    errorMessage: `There should be an operator after tag ${shortText}.`,
                  },
                  () => {
                    if (this.props.getLatestExpression) {
                      this.props.getLatestExpression(
                        this.state.expressionFormed,
                        false
                      );
                    }
                  }
                );
              }
            } else {
              shortText = addedObjects[index].shortText;
              this.setState(
                {
                  errorPosition: index,
                  validExpression: false,
                  errorMessage: `There should be an operator after tag ${shortText}.`,
                },
                () => {
                  if (this.props.getLatestExpression) {
                    this.props.getLatestExpression(
                      this.state.expressionFormed,
                      false
                    );
                  }
                }
              );
            }
          }
        }
      }
    }
  };

  /**
   * Method to check whether the first tag is not an operator
   */
  validateFirstTag = () => {
    const firstObject = this.state.objectsAdded[0];
    if (firstObject) {
      if (firstObject.objectType === 'operator') {
        if (LOGICAL_OPERATORS.indexOf(firstObject.shortText) > -1) {
          this.setState(
            {
              errorPosition: 0,
              validExpression: false,
              errorMessage: 'Expression starts with operator.',
            },
            () => {
              if (this.props.getLatestExpression) {
                this.props.getLatestExpression(
                  this.state.expressionFormed,
                  false
                );
              }
            }
          );
        } else {
          if (this.state.validExpression === false) {
            this.setState(
              {
                validExpression: true,
                errorMessage: '',
              },
              () => {
                if (this.props.getLatestExpression) {
                  this.props.getLatestExpression(
                    this.state.expressionFormed,
                    true
                  );
                }
              }
            );
          }
          this.isValidOperatorsBetweenOperands();
        }
      } else {
        this.isValidOperatorsBetweenOperands();
      }
    } else {
      this.isValidOperatorsBetweenOperands();
    }
  };

  /**
   * Method to check validation of the non leaf objects
   */
  validateNonLeafTag = () => {
    const addedObjects = this.state.objectsAdded;
    let lastObject;
    let operands = '';
    if (addedObjects.length > 0) {
      for (let index = 0; index < addedObjects.length - 1; index += 1) {
        if (addedObjects[index].objectType === 'operator') {
          if (index > 0) {
            lastObject = addedObjects[index - 1];
            if (lastObject.objectType === 'operand') {
              if (lastObject.recType === 'H') {
                if (operands.length > 0) {
                  operands = `${operands}, ${lastObject.shortText}`;
                } else if (operands.length === 0) {
                  operands = lastObject.shortText;
                }
              }
            }
          }
        }
      }
      lastObject = addedObjects[addedObjects.length - 1];
      if (lastObject.objectType === 'operand') {
        if (lastObject.recType === 'H') {
          if (operands.length > 0) {
            operands = `${operands}, ${lastObject.shortText}`;
          } else if (operands.length === 0) {
            operands = lastObject.shortText;
          }
        }
      }
    }
    if (operands.length > 0) {
      operands = `Select an answer for following - ${operands}`;
      this.setState(
        {
          validExpression: false,
          errorMessage: operands,
        },
        () => {
          if (this.props.getLatestExpression) {
            this.props.getLatestExpression(this.state.expressionFormed, false);
          }
        }
      );
    } else {
      if (this.state.validExpression === false) {
        this.setState(
          {
            validExpression: true,
          },
          () => {
            if (this.props.getLatestExpression) {
              this.props.getLatestExpression(this.state.expressionFormed, true);
            }
          }
        );
      }
      this.validateFirstTag();
    }
  };

  /**
   * Method to check validation of the last object
   */
  validateLastTag = (expressions, kpiExpression) => {
    const addedObjects = this.state.objectsAdded;
    const lastObject = addedObjects[addedObjects.length - 1];
    if (lastObject !== undefined) {
      if (
        lastObject.objectType === 'operator' &&
        lastObject.shortText !== ')'
      ) {
        if (this.state.validExpression === true) {
          this.setState(
            {
              errorPosition: addedObjects.length - 1,
              validExpression: false,
              errorMessage: 'Expression cannot end with an Operator.',
            },
            () => {
              if (this.props.getLatestExpression) {
                this.props.getLatestExpression(expressions, false);
              }
            }
          );
        }
      } else {
        if (this.state.validExpression === false) {
          this.setState({ validExpression: true }, () => {
            if (this.props.getLatestExpression) {
              this.props.getLatestExpression(expressions, true);
            }
          });
        }
        this.validateNonLeafTag();
        if (expressions.length !== 0) {
          this.fetchKPI(expressions, kpiExpression);
        }
      }
    } else {
      this.validateNonLeafTag();
    }
  };

  /**
   * Method to check whether the expression has balanced paranthesis
   */
  isBalancedParantheses = ipArray => {
    const stack = [];
    let errorPosition = -1;
    ipArray.map((val, index) => {
      if (val === '(') {
        errorPosition = index;
        stack.push(val);
      } else if (val === ')') {
        if (stack[stack.length - 1] === '(') {
          errorPosition = -1;
          stack.pop();
        } else {
          errorPosition = index;
          stack.push(val);
        }
      }
      return true;
    });
    this.setState({ errorPosition });
    return stack.length === 0;
  };

  /**
   * Method to check if the operator is repeated
   */
  isOperatorRepeated = ipArray => {
    const expCode = [];
    ipArray.map(v => {
      if (v === 'AND' || v === 'OR' || v === 'XOR') {
        expCode.push('o');
      } else if (v === '(') {
        expCode.push('(');
      } else if (v === ')') {
        expCode.push(')');
      } else {
        expCode.push('t');
      }
      return true;
    });
    const match =
      /oo+?/.exec(expCode.join('')) ||
      /o\)+?/.exec(expCode.join('')) ||
      /\(o+?/.exec(expCode.join('')) ||
      /\)t+?/.exec(expCode.join(''));
    return match ? match.index : undefined;
  };

  /**
   * Method to validate parenthesis of the expression
   */
  validateParenthesis = (expressions, kpiExpression) => {
    const errorPosition = this.isOperatorRepeated(this.state.expressionFormed);
    if (!this.isBalancedParantheses(this.state.expressionFormed)) {
      this.setState(
        {
          validExpression: false,
          errorMessage: 'One or more parenthesis is/are not closed.',
        },
        () => {
          if (this.props.getLatestExpression) {
            this.props.getLatestExpression(expressions, false);
          }
        }
      );
    } else if (errorPosition !== undefined) {
      this.setState(
        {
          errorPosition,
          validExpression: false,
          errorMessage: 'No consecutive operators allowed.',
        },
        () => {
          if (this.props.getLatestExpression) {
            this.props.getLatestExpression(expressions, false);
          }
        }
      );
    } else {
      this.setState(
        {
          validExpression: true,
          errorMessage: '',
        },
        () => {
          this.validateLastTag(expressions, kpiExpression);
          if (this.props.getLatestExpression) {
            this.props.getLatestExpression(expressions, true);
          }
        }
      );
    }
  };

  /**
   * Method to reset the smart search box
   */
  resetAll = () => {
    this.setState({
      tags: [],
      insight360_tags: [],
      insight360PersonalLabels: [],
      isDropdownFocus: false,
      searchResults: [],
      expressionFormed: [],
      objectsAdded: [],
      selectedCategory: 'ALL',
      selectedCategoryID: '-1',
      selectedKeyword: '',
      selectedCategoryQuestionID: '-1',
      selectedCategoryQuestionResults: [],
      selectedCategoryRecType: '',
      inputSearchString: '',
      validExpression: true,
      errorMessage: '',
      tagSelectedEditIndex: -1,
      errorPosition: -1,
      categoryListArr: [],
    });
    this.setTagFocus();
    if (this.categoryDropdownNode && this.categoryDropdownNode.current) {
      this.categoryDropdownNode.current.handleDictionaryReset();
    }
    if (this.props.removeKPI !== undefined) {
      this.props.removeKPI();
    }
    if (this.props.handleRemoveTags !== undefined) {
      this.props.handleRemoveTags();
    }
    if (this.props.resetAll) this.props.resetAll();
  };

  /**
   * Method to get the sample weighted value for datapoints
   */
  fetchKPI = (expressions, kpiExpression) => {
    if (this.props.moduleStudy) {
      let weightType = this.props.moduleStudy.wt;
      let divisor = this.props.moduleStudy.dv;
      let selectedModule = this.props.selectedModule
        ? this.props.selectedModule.toLowerCase()
        : 'crosstab';
      selectedModule =
        selectedModule === 'visahaul' ? 'stories' : selectedModule;
      const moduleWeightType = `${selectedModule}WeightTypes`;
      if (
        this.props[moduleWeightType] &&
        Array.isArray(this.props.moduleStudy.cw) &&
        this.props.moduleStudy.cw.length > 0
      ) {
        weightType = this.props[moduleWeightType].wt;
        divisor = this.props[moduleWeightType].dv;
      }
      const fetchKPIParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        divisor,
        expressionList: [expressions.join(' ')],
        weightType,
        kpiExpression,
      };
      if (this.props.selectedModule !== GEO_MAP_MODULE) {
        this.props.fetchKPI(fetchKPIParams);
      } else {
        this.props.geoMappingActions.setExpApiQueue(expressions).then(() => {
          this.props.geoMappingActions.fetchKPI(fetchKPIParams, expressions);
        });
      }
    }
  };

  /**
   * Move multiple Rows & columns to Cross tab ToolPallate
   */
  handleMultipleMove = (value, operation) => {
    let objSmartSearchArray = {};
    const expressionFormed = value.map(obj => [obj.keyword]);
    if (this.state.isAutocodePresent) {
      const newExpressionFormed = expressionFormed
        .map(exp => _.toString(exp))
        .filter(item => checkKeywords(item));

      getDicForDefKeywords(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        newExpressionFormed
      )
        .then(response => {
          objSmartSearchArray = value.map(obj => ({
            expressionFormed: [[obj.keyword]],
            objectsAdded: [obj],
            selectedCategoryID: this.state.selectedCategoryID,
            tags: [[obj.shortText]],
            autocodenode: buildAutoCodeObject([[obj.keyword]], [obj], response),
          }));
          this.handleCRBMultipleMove(value, operation, objSmartSearchArray);
        })
        .catch(e => {
          console.warn('Error while fetching Dictionary details ', e);
          objSmartSearchArray = value.map(obj => ({
            expressionFormed: [[obj.keyword]],
            objectsAdded: [obj],
            selectedCategoryID: this.state.selectedCategoryID,
            tags: [[obj.shortText]],
            autocodenode: buildAutoCodeObject([[obj.keyword]], [obj]),
          }));
          this.handleCRBMultipleMove(value, operation, objSmartSearchArray);
        });
    } else {
      objSmartSearchArray = value.map(obj => ({
        expressionFormed: [[obj.keyword]],
        objectsAdded: [obj],
        selectedCategoryID: this.state.selectedCategoryID,
        tags: [[obj.shortText]],
      }));
      this.handleCRBMultipleMove(value, operation, objSmartSearchArray);
    }
  };

  handleCRBMultipleMove = (value, operation, objSmartSearchArray) => {
    let weightType = this.props.moduleStudy.wt;
    let divisor = this.props.moduleStudy.dv;
    const moduleWeightType = `${this.props.selectedModule}WeightTypes`;
    if (
      this.props[moduleWeightType] &&
      Array.isArray(this.props.moduleStudy.cw) &&
      this.props.moduleStudy.cw.length > 0
    ) {
      weightType = this.props[moduleWeightType].wt;
      divisor = this.props[moduleWeightType].dv;
    }
    const selectedNames =
      operation === 'TargetDataGrid' || operation === 'BaseDataGrid'
        ? [value[0].shortText]
        : value.map(({ shortText }) => shortText);
    const recTypes =
      operation === 'TargetDataGrid' || operation === 'BaseDataGrid'
        ? [value[0].recType]
        : value.map(({ recType }) => recType);
    const sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      weightType,
      divisor,
      targetGrid: operation,
      gridData:
        this.props.gridData[operation] &&
        operation !== 'TargetDataGrid' &&
        operation !== 'BaseDataGrid'
          ? this.props.gridData[operation]
          : [],
      expressionList:
        operation === 'TargetDataGrid' || operation === 'BaseDataGrid'
          ? [value[0].keyword]
          : value.map(({ keyword }) => keyword),
      originalNames: selectedNames,
      selectedNames,
      recTypes,
      objSmartSearchArray,
    };
    this.props.getSampleWeighted(sampleWeightedParams);
    if (
      this.props.crosstab.crosstabTableList &&
      this.props.crosstab.crosstabTableList.length &&
      !this.props.dataPointsAlreadyAdded &&
      this.props.dataScreen !== 'DataHaul' &&
      this.props.selectedModule !== 'quickReports' &&
      this.props.selectedModule !== 'MME'
    ) {
      this.addAfterRunCrosstabModal.show();
    }
    if (
      this.props.crosstab.crosstabTableList &&
      this.props.crosstab.crosstabTableList.length &&
      !this.props.dataPointsAlreadyAdded &&
      this.props.dataScreen !== 'DataHaul' &&
      this.props.selectedModule !== 'quickReports'
    ) {
      this.props.dictionaryActions.setDataPointAlreadyAdded(true);
    }

    const objsAddedClone = [...this.state.objectsAdded];
    const tagsClone = [...this.state.tags];
    for (let i = this.state.objectsAdded.length - 1; i >= 0; i -= 1) {
      if (this.state.objectsAdded[i].objectType === 'operator') {
        break;
      } else {
        objsAddedClone.pop();
        tagsClone.pop();
      }
    }

    if (this.state.objectsAdded.length !== objsAddedClone.length) {
      this.setState({
        objectsAdded: objsAddedClone,
        tags: tagsClone,
        searchResults: [],
        errorMessage: '',
        validExpression: true,
      });
    }
    // this.setTagFocus();
  };

  /**
   * Method to handle smart search click
   */
  searchClick = e => {
    this.onTagInputBlur();
    if (
      (e.target.parentNode &&
        e.target.parentNode.getAttribute('data-listid') &&
        e.target.parentNode.getAttribute('data-listid') ===
          this.state.smartSearchListId) ||
      (e.target.getAttribute('data-listid') &&
        e.target.getAttribute('data-listid') ===
          this.state.smartSearchListId) ||
      e.target.classList.contains(`${this.state.inputClass}`) ||
      e.target.classList.contains('category-question') ||
      e.target.getAttribute('data-inputid') === this.state.inputId
    ) {
      this.setTagFocus();
    } else {
      this.setState({ tagFocus: false, isDropdownFocus: false });
    }
    if (
      e.target.parentNode.getAttribute('data-inputid') === this.state.inputId
    ) {
      this.setTagFocus();
    }
  };

  /**
   * allows editing the expression through smart search
   */
  editCrosstabGrid = (idKey, dataSmartSearch) => {
    this.resetAll();
    this.setState(
      {
        expressionFormed: [...dataSmartSearch.expressionFormed],
        objectsAdded: [...dataSmartSearch.objectsAdded],
        selectedCategoryID: dataSmartSearch.selectedCategoryID,
        tags: [...dataSmartSearch.tags],
      },
      () => {
        this.updateExpression();
        this.getDataForSuggestionDropdowns();
      }
    );
  };

  toggleSearchEditor = () => {
    if (this.state.expressionFormed.length > 0) {
      this.setState({ isSwitchClicked: false }, () => {
        this.modalDictionaryWarining.show();
      });
    } else {
      this.props.toggleSearchEditor();
    }
  };

  /**
   * Based on the tag selected Like (, AND, OR, NOT ETC respective suggestions
   * are made
   */
  doSetTagEditIndex = tagSelectedEditIndex => {
    if (tagSelectedEditIndex !== this.state.tagSelectedEditIndex) {
      this.setState(
        { tagSelectedEditIndex, inputSearchString: '', searchResults: [] },
        () => {
          this.getDataForSuggestionDropdowns();
        }
      );
    }
  };

  /**
   * Method to handle mouse over
   */
  mouseOver = e => {
    const event = e;
    event.currentTarget.childNodes[0].childNodes[0].src =
      event.currentTarget.childNodes[0].childNodes[0].dataset.hoversrc;
  };

  /**
   * Method to handle mouse out
   */
  mouseOut = e => {
    const event = e;
    event.currentTarget.childNodes[0].childNodes[0].src =
      event.currentTarget.childNodes[0].childNodes[0].dataset.src;
  };

  getPlaceholderForSmartSearchInput = () => {
    if (
      this.props.selectedModule === CROSSTAB_CONSTANT ||
      this.props.selectedModule === DATAHAUL_CONSTANT ||
      this.props.selectedModule === QUICKREPORTS_CONSTANT
    ) {
      return 'Search for data. Ctrl or Shift prior to first selection for multi-select.';
    }
    if (this.props.dataScreen === 'insight360') {
      if (
        this.props.selectedTab === INSIGHT360_EXPLORE ||
        this.props.selectedTab === INSIGHT360_REPORTS
      ) {
        return 'Search for data. Select up to 3 personas to compare.';
      }
      return 'Search for data. Select one persona.';
    }
    return 'Enter Search Term';
  };

  /**
   * Input text box of smartsearch where search values are typed
   */
  tagRenderInput = props => (
    <input
      type="text"
      id="tag-input-box"
      data-inputid={this.state.inputId}
      {...props}
      autoComplete="off"
      placeholder={this.getPlaceholderForSmartSearchInput()}
      maxLength="400"
      // onBlur={() => this.onTagInputBlur()}
    />
  );

  /**
   * Based on Brand or Pitch button clicked for SalesCatalyst
   * Respective dropdown is made visible
   */
  showInputsDataPointsSelection = (type, flag) => {
    if (this.state.validExpression) {
      if (type === SALES_CATALYST_DATA_SELECTION) {
        this.setState({
          popupApplyVisible: flag,
        });
      }

      if (flag === false) {
        this.resetAll();
        this.props.gridData.kpiInfo = undefined;
      }
    }
  };

  /**
   * Adding Audience(1) , SubAudience(3), Competitors(3), Market(1)
   * for Brand or Pitch of salesCatalyst reducer through the fucntion
   * addInputDataPointsSelection exposed through props.
   */
  validateAddSpecificSelection = (data, category, type) => {
    if (availableToAddSpecificSelection(data, category)) {
      let expressionsId = null;
      let definationId = null;
      if (this.state.selectedCategoryRecType === 'D') {
        const tagName = _.clone(this.state.insight360_tags);
        const object = _.clone(this.state.definationTargetData).find(
          obj => obj.title === tagName[0].trimStart()
        );
        if (!_.isEmpty(object) && typeof object.expressionId !== 'undefined') {
          expressionsId = object.expressionId;
          definationId = object.ovDefinitionId;
        }
      } else {
        expressionsId = null;
        definationId = null;
      }
      this.props.addInputDataPointsSelection(
        {
          label: this.state.tags.join(' '),
          expression: this.state.expressionFormed.join(' '),
          sample: this.props.gridData.kpiInfo.intab,
          weighted: this.props.gridData.kpiInfo.weighted,
          expId: expressionsId,
          defId: definationId,
        },
        type,
        _.camelCase(category)
      );
    }
    this.showInputsDataPointsSelection(type, false);
  };

  getWrapperClassname = module => {
    switch (module) {
      case 'insight360': {
        return 'categorized-smartsearch-input-wrapper insight360-smartsearch-input-wrapper';
      }
      case 'QuickReports': {
        return 'categorized-smartsearch-input-wrapper quick-reports-smart-search';
      }
      case 'salescatalyst': {
        if (
          this.props.dataScreenType &&
          this.props.dataScreenType === 'salescatalystConfig'
        ) {
          return 'categorized-smartsearch-input-wrapper sales-catalyst-config-smart-search';
        }
        return 'categorized-smartsearch-input-wrapper';
      }
      case 'salescatalystConfig': {
        return 'categorized-smartsearch-input-wrapper sales-catalyst-config-smart-search';
      }
      case 'userPreferences': {
        return 'categorized-smartsearch-input-wrapper preference-smart-search';
      }
      case 'DataHaul': {
        return 'categorized-smartsearch-input-wrapper';
      }
      default: {
        return 'categorized-smartsearch-input-wrapper';
      }
    }
  };

  getCategoryDropdownWrapperClass = module => {
    switch (module) {
      case 'insight360': {
        // to be updated when changes for insight360
        return 'categorized-smart-search-dropdown-wrapper insight360-smart-search-dropdown-wrapper';
      }
      default: {
        return 'categorized-smart-search-dropdown-wrapper';
      }
    }
  };

  render() {
    let selectedModule = this.props.selectedModule
      ? this.props.selectedModule.toLowerCase()
      : 'crosstab';
    selectedModule = selectedModule === 'visahaul' ? 'stories' : selectedModule;
    const moduleWeightType = `${selectedModule}WeightTypes`;
    return (
      <div>
        <div
          className={this.getCategoryDropdownWrapperClass(
            this.props.selectedModule
          )}
        >
          <ButtonToolbar>
            <DropdownButton
              className={`
              btn-group btn-group-default
                ${
                  !_.isEmpty(this.state.categoryListArr) &&
                  this.state.tagFocus &&
                  (this.state.selectedCategory === 'ALL' ||
                    this.state.selectedCategory === 'Definitions' ||
                    this.state.selectedCategory === 'Dictionary' ||
                    this.state.selectedCategory === 'Turn-Key Omnibus' ||
                    this.state.selectedCategory === 'Geographies')
                    ? 'category-dropdown-border'
                    : ''
                }`}
              bsstyle="default"
              title={this.state.selectedCategory}
              key="1"
              id="category"
              show={this.state.categoryDropdown}
              onToggle={() => {
                // if (this.props.dictionaryTree === undefined) {
                //   // get Dictionary tree loaded
                //   this.props.dictionaryActions.getDictionaryTreeLoad(
                //     this.props.loginResponse.data.token,
                //     this.props.loginResponse.data.uid,
                //     this.props.activeAccountId,
                //     this.props.moduleStudy.pn,
                //     0,
                //     'SIMMONS_DATA',
                //   );
                // }
                if (this.props.qtsDictionaryTree === undefined) {
                  // get QTS tree loaded
                  this.props.qtsActions.getDictionaryTreeLoad(
                    this.props.loginResponse.data.token,
                    this.props.loginResponse.data.uid,
                    this.props.activeAccountId,
                    this.props.moduleStudy.pn,
                    0,
                    'qts'
                  );
                }
                this.setState({
                  categoryDropdown: !this.state.categoryDropdown,
                });
              }}
              ref={node => (this.categoryDropdownButton = node)}
            >
              <CategoryDropdown
                selectedModule={this.props.selectedModule}
                ref={this.categoryDropdownNode}
                moduleStudy={this.props.moduleStudy}
                activeAccountId={this.props.activeAccountId}
                handleCategoryChange={this.onCategoryChange}
                selectedCategoryID={this.state.selectedCategoryID}
                handleReset={this.resetAll}
              />
            </DropdownButton>
          </ButtonToolbar>
          {Object.keys(this.state.categoryListArr).length > 0 &&
            this.state.inputSearchString.length > 1 &&
            (this.state.selectedCategory === 'ALL' ||
              this.state.selectedCategory === 'Definitions' ||
              this.state.selectedCategory === 'Dictionary' ||
              this.state.selectedCategory === 'Turn-Key Omnibus' ||
              this.state.selectedCategory === 'Geographies') && (
              <CategorySubCatgDropdownList
                ref={catgSubCatgFilter =>
                  (this.categoryListFilter = catgSubCatgFilter)
                }
                categories={this.state.categoryListArr}
                tagFocus={this.state.tagFocus}
                onSelectCategory={this.onSelectCategory}
                uniqueId={this.state.smartSearchListId}
                searchClick={this.onTagInputBlur}
                dropdownBlur={isDropdownFocus =>
                  this.setState({ isDropdownFocus })
                }
              />
            )}
        </div>
        <div className={this.getWrapperClassname(this.props.selectedModule)}>
          <div className="kpi-wrapper">
            {this.props.selectedModule !== GEO_MAP_MODULE &&
              this.props.moduleStudy &&
              !this.props.moduleStudy.st
                .toLowerCase()
                .includes(FLEX_STUDY_TAG) && (
                <p>
                  {this.state.expressionFormed.length > 0 &&
                  this.props.gridData &&
                  this.props.gridData.kpiInfo &&
                  this.props.gridData.kpiInfo.intab !== undefined &&
                  this.props.gridData.kpiInfo.intab !== null ? (
                    <span>
                      <span>
                        Sample:&nbsp;
                        <span className="sample-value">
                          {numberWithCommas(this.props.gridData.kpiInfo.intab)}
                        </span>
                        &nbsp;&nbsp;/&nbsp;&nbsp;
                      </span>
                      <span>
                        Weighted {checkWeightType(this.props[moduleWeightType])}
                        :&nbsp;
                        <span className="weighted-value">
                          {this.props.gridData.kpiInfo.weighted === undefined
                            ? numberWithCommas(0)
                            : numberWithCommas(
                              roundWeighted(this.props.gridData.kpiInfo.weighted)
                              )}
                        </span>
                      </span>
                    </span>
                  ) : (
                    ''
                  )}
                </p>
              )}
            {this.props.selectedModule === GEO_MAP_MODULE &&
              this.props.moduleStudy && (
                <p>
                  {this.state.expressionFormed.length > 0 &&
                  this.props.gridData &&
                  this.props.gridData.kpiInfo &&
                  this.props.gridData.kpiInfo.intab !== undefined &&
                  this.props.gridData.kpiInfo.intab !== null ? (
                    <span>
                      <span>
                        Sample:&nbsp;
                        <span className="sample-value">
                          {numberWithCommas(this.props.gridData.kpiInfo.intab)}
                        </span>
                        &nbsp;&nbsp;/&nbsp;&nbsp;
                      </span>
                      <span>
                        Weighted:&nbsp;
                        <span className="weighted-value">
                          {this.props.gridData.kpiInfo.weighted === undefined
                            ? numberWithCommas(0)
                            : numberWithCommas(
                              roundWeighted(this.props.gridData.kpiInfo.weighted)
                              )}
                        </span>
                      </span>
                    </span>
                  ) : (
                    ''
                  )}
                </p>
              )}

            {/* {!(this.props.dataScreenType === 'salescatalystConfig' ||
            this.props.selectedModule === 'salescatalyst' ||
            this.props.selectedModule === 'userPreferences' ||
            this.props.selectedModule === CROSSTAB_CONSTANT ||
            this.state.inputSearchString.length < 2 || this.state.searchResults.length === 0)
            && <p className="multiselcet-text">
              {this.props.dataScreen === 'insight360'
                ? `${this.props.selectedTab === INSIGHT360_EXPLORE ||
                  this.props.selectedTab === INSIGHT360_REPORTS
                  ? 'Select up to 3 personas to compare.'
                  : 'Select one persona.'}`
                  : 'Ctrl or Shift prior to first selection for multi-select'}
            </p>} */}
          </div>
          <TagsInput
            ref={tags => (this.tagsInput = tags)}
            value={this.state.tags}
            onChange={this.handleRemoveTagsInput}
            onChangeInput={this.handleChangeInput}
            inputValue={this.state.inputSearchString}
            handleAdd={() => {
              if (this.custDropdown) {
                this.custDropdown.handleAdd();
              }
            }}
            renderInput={this.tagRenderInput}
            onBlur={this.onTagInputBlur}
            getDataForSuggestionDropdowns={this.getDataForSuggestionDropdowns}
            className={`react-tagsinput ${this.state.inputClass} ${
              !this.state.validExpression ? 'taginput-invalid' : ''
            } ${this.props.isTagInputExpanded ? '' : 'outOfFocus'}
              ${
                this.state.tagFocus &&
                (this.state.searchResults.length > 0 ||
                  (this.state.searchResults.length === 0 &&
                    this.state.inputSearchString.length > 1))
                  ? 'remove-border-radius'
                  : ''
              }`}
            objectsAdded={this.state.objectsAdded}
            doSetTagEditIndex={this.doSetTagEditIndex}
            resetAll={this.resetAll}
            errorPosition={this.state.errorPosition}
            errorMessage={this.state.errorMessage}
            dataInputId={this.state.inputId}
          />
          <CategorizedCustomDropdown
            ref={tags => (this.custDropdown = tags)}
            tagFocus={this.state.tagFocus}
            suggestions={this.state.searchResults}
            inputValue={this.state.inputSearchString}
            selectedModule={this.props.selectedModule}
            uniqueId={this.state.smartSearchListId}
            handleSelect={this.handleSelect}
            study={this.state.studyID}
            dataScreen={this.props.dataScreen}
            noSearchResultsFound={this.state.noSearchResultsFound}
            dropdownBlur={isDropdownFocus => this.setState({ isDropdownFocus })}
            tagSelectedEditIndex={this.state.tagSelectedEditIndex}
            trackerFn={this.props.trackerFn}
            categoryList={this.state.categoryListArr}
            isOperandSearch={this.state.isOperandSearch}
          />
        </div>
        <Modal
          title=""
          ref={node => (this.modalDictionaryWarining = node)}
          dialogStyles={modalDictionaryWariningStyle}
        >
          <div className="large-12 columns">
            <div className="column row expanded">
              <div className="row column">
                <div className="large-12 text-center columns">
                  <FontAwesome
                    className="warning-img"
                    name="open"
                    size="4x"
                    style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                    aria-hidden="true"
                  />
                </div>
              </div>
              <p>
                You are now leaving Smart Search. Any data in your search bar
                will now be deleted. However, the data in your crosstab grid
                will remain. Do you want to continue?
              </p>
              <div className="row column">
                <div className="large-6 text-center columns">
                  <Link
                    className="button  btn-yes button-125px"
                    onClick={
                      !this.state.isSwitchClicked
                        ? () => {
                            this.resetAll();
                            this.props.toggleSearchEditor();
                          }
                        : () => {
                            this.resetAll();
                            this.modalDictionaryWarining.hide();
                          }
                    }
                  >
                    Yes
                  </Link>
                </div>
                <div className="large-6 text-center columns">
                  <GenericButton
                    name="Cancel"
                    btnStyle="button btn-cncl button-125px"
                    onBtnClick={() => this.modalDictionaryWarining.hide()}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => (this.modalDataHaulBaseWarining = node)}
          dialogStyles={modalDataHaulWariningStyle}
        >
          <div className="text-center">
            <p>
              You have reached the maximum allowed 1 Base for Data Mine. Please
              reduce the number of bases and run again.
            </p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => this.modalDataHaulBaseWarining.hide()}
            />
          </div>
        </Modal>
        <Modal
          title="Run Crosstab"
          ref={node => (this.addAfterRunCrosstabModal = node)}
          dialogStyles={addAfterRunCrosstabModalStyle}
        >
          <p>You have added a new data point. Please Run report again.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.addAfterRunCrosstabModal.hide()}
          />
        </Modal>
        <Modal
          title="Max target limit reached"
          ref={node => (this.targetMaxLimitModal = node)}
          dialogStyles={targetMaxLimitModalStyle}
        >
          <p>
            MME reports can include up to {urls.MME_TARGET_COUNT_IN_WORDS}{' '}
            targets.
          </p>
          <p>
            To add more targets please delete one or more of your previously
            selected targets.
          </p>
          <div className="text-right">
            <GenericButton
              name="Ok"
              onBtnClick={() => this.targetMaxLimitModal.hide()}
            />
          </div>
        </Modal>
        <Modal
          title="Run Report"
          ref={node => (this.runReportModal = node)}
          dialogStyles={runReportModalStyle}
        >
          <p>A data point was added, edited or deleted.</p>
          <p>Please run your report again to view updated selection(s).</p>
          <div className="text-right">
            <GenericButton
              name="Ok"
              onBtnClick={() => this.runReportModal.hide()}
            />
          </div>
        </Modal>
        {this.props.dataScreen === 'insight360' &&
          this.state.expressionFormed.length > 0 &&
          this.props.gridData.kpiInfo && (
            <div className="pull-right" style={{ width: '21%' }}>
              <p className="error-text">
                {this.props.gridData.kpiInfo.intab < 60 &&
                  this.props.gridData.kpiInfo.intab !== 0 &&
                  INSIGHT_360_LESS_BASE_WARNING}
                {this.props.gridData.kpiInfo.intab === 0 &&
                  INSIGHT_360_SAMPLE_SIZE_WARNING}
              </p>
            </div>
          )}
      </div>
    );
  }
}

SmartSearch.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTargetLoad: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    setDataPointAlreadyAdded: PropTypes.func,
    getDictionaryTreeLoad: PropTypes.func,
  }),
  loginActions: PropTypes.shape({
    setSmartSearchView: PropTypes.func,
  }),
  qtsActions: PropTypes.shape({
    getDictionaryTreeLoad: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    st: PropTypes.string,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
    ss: PropTypes.string,
  }),
  toggleSearchEditor: PropTypes.func,
  fetchKPI: PropTypes.func,
  removeKPI: PropTypes.func,
  gridData: PropTypes.shape({
    selectedReport: PropTypes.shape({}),
    kpiInfo: PropTypes.shape({
      intab: PropTypes.number,
      weighted: PropTypes.number,
    }),
  }),
  getSampleWeighted: PropTypes.func,
  selectedModule: PropTypes.string,
  selectedTab: PropTypes.string,
  dataScreen: PropTypes.string,
  dataScreenType: PropTypes.string,
  runDataHaul: PropTypes.func,
  definationTarget: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  definationTargetList: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  defination: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  handleRemoveTags: PropTypes.func,
  crosstab: PropTypes.shape({
    crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  }),
  dataPointsAlreadyAdded: PropTypes.bool,
  qtsDictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  dictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  salesCatalystBase: PropTypes.shape({}),
  setSalesCatalystBase: PropTypes.func,
  resetSalesCatalyst: PropTypes.func,
  runSalesCatalyst: PropTypes.func,
  tabInfoSalesCatalyst: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  uniqueIdName: PropTypes.string,
  resetInputInfo: PropTypes.bool,
  additionalTabInfo: PropTypes.shape({}),
  getLatestExpression: PropTypes.func,
  showToggleView: PropTypes.bool,
  switchSmartSearchView: PropTypes.func,
  geographyActions: PropTypes.shape({
    handleSearchGeographyTreeLoad: PropTypes.func,
    handleGeographySearch: PropTypes.func,
    clearGeographySmartSearchData: PropTypes.func,
  }),
  isEnableMMEViewer: PropTypes.bool,
  geoMappingActions: PropTypes.shape({
    setExpApiQueue: PropTypes.func,
    fetchKPI: PropTypes.func,
  }),
  allFeatures: PropTypes.arrayOf(PropTypes.array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    trendStudies: state.study.trendStudies,
    defination: state.definition.definitionTree,
    definationTarget: state.definition.definitionTarget,
    definationTargetList: state.definition.definitionTreeList,
    error: state.insight360.error,
    study: state.study,
    crosstab: state.crosstab,
    geographySmartSearch: state.geographies.geographySmartSearch,
    dataPointsAlreadyAdded: state.dataPointsAlreadyAdded,
    qtsDictionaryTree: state.qts.qtsDictionaryTree,
    dictionaryTree: state.dictionary.dictionaryTree,
    salesCatalystBase: state.salesCatalyst.salesCatalystBase,
    scDataSelection: state.salesCatalyst.dataSelection,
    scDataOnScreen: state.salesCatalyst.dataOnScreen,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    isEnableMMEViewer: state.mme.isEnableMMEViewer,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
    datahaulWeightTypes: state.study.datahaulWeightTypes,
    storiesWeightTypes: state.study.storiesWeightTypes,
    mmeWeightTypes: state.study.mmeWeightTypes,
    geoWeightTypes: state.study.geoWeightTypes,
    allFeatures: state.userDetail.allFeatures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    definitionActions: bindActionCreators(definitionActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
    qtsActions: bindActionCreators(qtsActions, dispatch),
    geographyActions: bindActionCreators(geographyActions, dispatch),
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(SmartSearch);
